import ToolbarItemBasic from "toolbar/ToolbarItemBasic";
import AddContentModal from "content/AddContentModal";
import Toolbar from "toolbar/Toolbar";
import ContentPostCaseStudy from "./ContentPostCaseStudy";
import ContentPostTestimonial from "./ContentPostTestimonial";
import ContentPost from "content/ContentPost";

Toolbar.addDefaultItem(new ToolbarItemBasic('Add a Case Study', () => (new AddContentModal('21f9a6e11f806c87')).show(), 'plus'));
//Toolbar.addDefaultItem(new ToolbarItemBasic('Add a Testimonial', () => (new AddContentModal('a9ba4074ab33b261')).show(), 'plus'));

ContentPost.register_post_editor('21f9a6e11f806c87', ContentPostCaseStudy);
//ContentPost.register_post_editor('a9ba4074ab33b261', ContentPostTestimonial);